import React from 'react'
import '../style/ModificaPiano.scss'
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import StarIcon from '@mui/icons-material/Star';
import { useSelector } from 'react-redux';

function ModificaPiano() {
    const idGroup = useSelector((user) => user.user.idGruppo)
    
    const price = () => {
        switch (idGroup) {
            case 1:
                return (
                    <>
                        <SentimentSatisfiedAltIcon /> <p className="price">0,21 <span>€/kWh</span></p>
                    </>
                )
            case 2: 
                return (
                    <>
                        <SentimentDissatisfiedIcon /> <p className="price">0,23 <span>€/kWh</span></p>
                    </>
                )
            case 3:
                return (
                    <>
                        <SentimentVeryDissatisfiedIcon /> <p className="price">0,25 <span>€/kWh</span></p>
                    </>
                )
            default:
                break;
        }
    }
    return (
        <div className="modificaPiano">
            <div className="header">
                <h2>Modifica piano</h2>
                <p>Lorem ipsum dolor sit amet, consecteur adipiscing elit, sed do eiusmod tempor incididunt.</p>
            </div>
            <div className={`yourPrice ${idGroup === 1 ? 'green' : idGroup === 2 ? 'orange' : 'red'}`}>
                <div className="favorite">
                    <StarIcon/>
                </div>
                <p className="label">Il tuo prezzo:</p>
                {price()}
            </div>
        </div>
    )
}

export default ModificaPiano
